// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const shadows = {
  medium: '0px 0px 1px rgba(22, 29, 45, 0.15), 0px 0px 4px rgba(22, 29, 45, 0.08)'
} as const;

export default shadows;
